module.exports = __webpack_public_path__ + "static/media/greeneryA.d87ff2e1.jpg";